import appStoreBadgeImage from './appStoreBadge.png'
import checkedImage from './checked.png'
import envelopeImage from './envelope.png'
import getItOnGooglePlayBadgeWebImage from './getItOnGooglePlayBadgeWeb.png'
import mockedEventImage from './mockedEventImage.jpg'
import sadPensiveFaceImage from './sadPensiveFace.png'
import warningImage from './warning.png'

export {
  appStoreBadgeImage,
  checkedImage,
  envelopeImage,
  getItOnGooglePlayBadgeWebImage,
  mockedEventImage,
  sadPensiveFaceImage,
  warningImage,
}
